import { render } from "./SalesByPOSLocation.vue?vue&type=template&id=b229c20c&ts=true"
import script from "./SalesByPOSLocation.vue?vue&type=script&lang=ts"
export * from "./SalesByPOSLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__